"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocked = undefined;

var _factory = require("./factory");

var trackerFactory = _interopRequireWildcard(_factory);

var _schemas = require("./schemas");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var applyDefaultsToConfigSchema = function applyDefaultsToConfigSchema(trackerDependencies, schema) {
  schema.debug.default = trackerDependencies.getDebug;
  schema.onError.default = trackerDependencies.reportError;
  return schema;
};

var applyDefaultsToTrackerPropertiesSchema = function applyDefaultsToTrackerPropertiesSchema(trackerDependencies, schema) {
  schema.email.default = trackerDependencies.getEmail;
  schema.hubId.default = trackerDependencies.getHubId;
  schema.hstc.default = trackerDependencies.getHstc;
  schema.lang.default = trackerDependencies.getLang;
  return schema;
};

var adaptTrackerDependencies = function adaptTrackerDependencies(trackerDependencies) {
  var createDictionary = trackerDependencies.createDictionary,
      createIdentifiers = trackerDependencies.createIdentifiers,
      createEvent = trackerDependencies.createEvent,
      logError = trackerDependencies.logError,
      logMessage = trackerDependencies.logMessage,
      onTrack = trackerDependencies.onTrack,
      rest = _objectWithoutProperties(trackerDependencies, ["createDictionary", "createIdentifiers", "createEvent", "logError", "logMessage", "onTrack"]);

  return {
    createDictionary: createDictionary,
    createIdentifiers: createIdentifiers,
    createEvent: createEvent,
    logError: logError,
    logMessage: logMessage,
    onTrack: onTrack,
    schemas: {
      configSchema: _schemas.configSchema.mutate(function (schema) {
        return applyDefaultsToConfigSchema(rest, schema);
      }),
      trackerPropertiesSchema: _schemas.trackerPropertiesSchema.mutate(function (schema) {
        return applyDefaultsToTrackerPropertiesSchema(rest, schema);
      })
    }
  };
};

var createLocked = exports.createLocked = function createLocked(trackerDependencies, config) {
  var adaptedTrackerDependencies = adaptTrackerDependencies(trackerDependencies);
  return trackerFactory.createLocked(adaptedTrackerDependencies, config);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.87/js/tracker/index.js
// module id = 414
// module chunks = 0